import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Advertisers from "../pages/advertisers/page";
import Investors from "../pages/investors/page";
import About from "../pages/about/pages";
import Contact from "../pages/contact/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/advertisers",
    element: <Advertisers />,
  },
  {
    path: "/investors",
    element: <Investors />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "/contact",
    element: <Contact />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;